/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2022.04.19.
 * @Author
 * @Description 企微、企点 - 常数、数组、对象 定义.
 **/

import { i18n } from '@/i18n'
import { getCurrentLanguage } from '@hgj/common-tools'
const { t } = i18n.global

/** 应用名称 */
export const appName = 'saas-insurance'

/** 是否海外环境 */
export const isGlobal = import.meta.env.VITE_IS_GLOBAL === 'true'
/** 海外环境标识 */
export const globalFlag = isGlobal ? 'global' : ''
export const lang = getCurrentLanguage()
export const isEn = lang === 'en'
export const isGlobalEn = isGlobal && isEn

/**
 *@Description 分页数据 .
 *@Return .
 **/
export const returnPage = (size?: number) => {
  return {
    pageNo: 1, // 当前所在页
    pageSize: size || 10, // 每页多少条
    total: 0, // 总页数
  }
}

/**
 *@Description 企业 认证 中台 域名 .
 *@Return .
 **/
export const enterpriseFormDomain: Record<string, string> = {
  'prod-': 'https://i.hgj.com/enterprise/auth',
  'dev-': 'https://dev-i.hgj.com/enterprise/auth',
  'beta-': 'https://beta-i.hgj.com/enterprise/auth',
}
/**
 *@Description 获取中台不同 环境 域名下的token .
 *@Return .
 **/
export const jointPlatformDomain: Record<string, string> = {
  'prod-': import.meta.env.VITE_USER_LOGIN,
  'dev-': import.meta.env.VITE_USER_LOGIN,
  'beta-': import.meta.env.VITE_USER_LOGIN,
}

/**
 *@Description nas 环境 域名 .
 *@Return .
 **/
export const domainNameObj: Record<string, string> = {
  'dev-': isGlobal
    ? 'https://dev-ingress.globalhgj.com/whale-nas-manager-server'
    : 'https://iter-apisix.hgj.com/whale-nas-manager-server',
  'beta-': isGlobal
    ? 'https://beta-ingress.globalhgj.com/whale-nas-manager-server'
    : 'https://beta-apisix.hgj.com/whale-nas-manager-server',
  'prod-': isGlobal
    ? 'https://hwfileingress.hgj.com/whale-nas-manager-server'
    : 'https://file-ingress.hgj.com/whale-nas-manager-server',
}
/** 出单状态枚举 */
export const opstatusEnum = {
  /** 草稿 */
  DRAFT: '22',
  /** 待申报 */
  PENDING: '01',
  /** 已申报 */
  SUBMITTED: '02',
  /** 审核中 */
  AUDITING: '03',
  /** 已出单 */
  ISSUED: '04',
  /** 批改中 */
  CORRECTION: '20',
  /** 批改失败 */
  CORRECTION_FAILED: '21',
  /** 已退回 */
  RETURNED: '06',
  /** 已撤单 */
  CANCELLED: '07',
  /** 撤单审核中 */
  CANCELLED_AUDITING: '09',
  /** 保司投保退回- 客户端展示审核中 */
  RETURNED_BY_INSURANCE_COMPANY: '26',
  /** 投保失败- 客户端展示审核中 */
  SUBMITTED_FAIL: '27',
  /** 待签发 */
  PENDING_ISSUED: '25',
}
/**
 *@Description 投保 状态 出单状态 .
 *@Return
 * 恪保：状态 01草稿 02已提交 03录单中 04已出单 05重新处理 06已退回 07撤单 08客户删除草稿件
 * 小牛：0.投保中；1.草稿；2.已提交；3.已拒绝；4.已出单；5.已注销 .
 *
 * 出单状态：
 * 小牛：暂存单-未申报。未出单-已提交。出单中-已接单审核中。已出单-已出单。退回修改-已退回。已撤单-已撤单。
 * 恪保：草稿-未申报。已提交-已提交。录单中-已接单审核中。已出单-已出单。已退回-已退回。撤单-已撤单。
 **/
export const returnIssueStatus = () => {
  return [
    {
      value: opstatusEnum.DRAFT,
      label: t('status.draft'),
      auth: ['INFO', 'EDIT', 'DELETE'],
    },
    {
      value: opstatusEnum.PENDING,
      label: t('status.pending'),
      auth: ['INFO', 'EDIT', 'PREVIEW', 'DELETE'],
    },
    {
      value: opstatusEnum.SUBMITTED,
      label: t('status.submitted'),
      auth: ['INFO', 'PREVIEW'],
    },
    {
      value: opstatusEnum.AUDITING,
      label: t('status.auditing'),
      auth: ['INFO', 'PREVIEW'],
    },
    {
      value: opstatusEnum.RETURNED_BY_INSURANCE_COMPANY,
      label: t('status.auditing'),
      auth: ['INFO', 'PREVIEW'],
    },
    {
      value: opstatusEnum.SUBMITTED_FAIL,
      label: t('status.auditing'),
      auth: ['INFO', 'PREVIEW'],
    },
    {
      value: opstatusEnum.ISSUED,
      label: t('status.issued'),
      auth: ['INFO', 'EDIT', 'EPOLICY'],
    },
    {
      value: opstatusEnum.CORRECTION,
      label: t('status.correction'),
      auth: ['INFO', 'EDIT'],
    },
    {
      value: opstatusEnum.CORRECTION_FAILED,
      label: t('status.correctionFailed'),
      auth: ['INFO', 'EDIT', 'EPOLICY'],
    },
    {
      value: opstatusEnum.RETURNED,
      label: t('status.returned'),
      auth: ['INFO', 'EDIT', 'DELETE'],
    },
    {
      value: opstatusEnum.CANCELLED,
      label: t('status.cancelled'),
      auth: ['INFO'],
    },
    {
      value: opstatusEnum.CANCELLED_AUDITING,
      label: t('status.cancelledAuditing'),
      auth: ['INFO'],
    },
    {
      value: opstatusEnum.PENDING_ISSUED,
      label: t('status.pendingIssued'),
      auth: ['INFO', 'PAY'],
    },
  ].filter((i) =>
    isGlobal ? !['01', '02', '20', '25'].includes(i.value) : true,
  )
}

/**
 * @Description 当前投保状态的操作按钮展示权限.
 */
export const returnAuthOps = returnIssueStatus()?.reduce((acc: any, cur) => {
  acc[cur.value] = cur?.auth || []
  return acc
}, {})

export const returnQueryTypeOptions = () => {
  return [
    {
      value: 0,
      label: t('common.all'),
    },
    {
      value: 1,
      label: t('insuranceType.export'),
    },
    {
      value: 2,
      label: t('insuranceType.import'),
    },
    {
      value: 3,
      label: t('insuranceType.domestic'),
    },
    {
      value: 4,
      label: t('insuranceType.domesticNonHighway'),
    },
    {
      value: 5,
      label: t('insuranceType.crossBorder'),
    },
  ].filter((i) => (isGlobal ? ![3, 4].includes(i.value) : true))
}

// const returnOps = returnIssueStatus()?.reduce((acc:any, cur) => {
//     acc[cur.value] = cur.label
//     return acc
// }
// , {})
export const returnOpstatus = (data: any) => {
  const s = data.opstatus || 999
  // const code = data?.supplyCode || '-' // 恪保：KB，小牛：XN

  const ops = returnIssueStatus()?.reduce((acc: any, cur) => {
    acc[cur.value] = cur.label
    return acc
  }, {})

  const obj: Record<string, string> = {
    ...(ops || {}),
    '08': t('status.deleted'),
    999: '-',
  }

  return obj[s]
}
export const returnOpClass = (data: any) => {
  const s = data.opstatus || 999
  // const code = data?.supplyCode || '-' // 恪保：KB，小牛：XN

  const obj: Record<string, string> = {
    '22': 's-gray',
    '01': 's-gray',
    '02': 's-blue',
    '03': 's-blue',
    '26': 's-blue',
    '27': 's-blue',
    '04': 's-green',
    '20': 's-blue',
    '21': 's-red',
    '06': 's-red',
    '07': 's-gray',
    '08': 's-red',
    '09': 's-red',
    '25': 's-gray',
    999: '-',
  }

  return `status ${obj[s]}`
}
export const returnSationClass = (data: any) => {
  const s = data.compensationStatus || 999
  // const code = data?.supplyCode || '-' // 恪保：KB，小牛：XN

  const obj: Record<string, string> = {
    '1': 's-blue',
    '2': 's-blue',
    '3': 's-yellow',
    '4': 's-green',
    '9': 's-gray',
    999: '-',
  }

  return `status ${obj[s]}`
}
/**
 *@Description 返回 保险 公司 .
 *@Return .
 **/
export const returnInsuranceCompany = (data: any) => {
  const code = data?.supplyCode || '-'
  const o: Record<string, string> = {
    KB: t('company.kb'),
    XN: t('company.xn'),
    '-': '-',
  }
  return o[code]
}
export const getSourceOptions = () => {
  return [
    {
      value: 'ONLINE',
      label: t('source.online'),
    },
    {
      value: 'IMPORT',
      label: t('source.templateImport'),
    },
    {
      value: 'SAAS',
      label: t('source.saas'),
    },
    {
      value: 'JOINT',
      label: t('source.joint'),
    },
    {
      value: 'DC',
      label: t('source.dc'),
    },
    {
      value: 'WEB',
      label: t('source.web'),
    },
    {
      value: 'CB',
      label: t('source.cross'),
    },
    {
      value: 'GZH',
      label: t('source.gzh'),
    },
    {
      value: 'GZHGG',
      label: t('source.gzhgg'),
    },
    {
      value: 'DYH',
      label: t('source.dyh'),
    },
    {
      value: 'SQ',
      label: t('source.sq'),
    },
    {
      value: 'SPH',
      label: t('source.sph'),
    },
    {
      value: 'TC',
      label: t('source.tc'),
    },
    {
      value: 'BANNER',
      label: 'banner',
    },
    {
      value: 'AGENT',
      label: '代投保',
    },
  ]
}
export const getSourceStr = (source: string) => {
  return getSourceOptions().find((item) => item.value === source)?.label || ''
}
/**
 *@Description 根据 路由 返回 code .
 *@Return
 * 海运出口         "productcode": "CA06",         "transporttypecode": "1",
 * 海运进口         "productcode": "CA05",         "transporttypecode": "1",
 * 空运出口        "productcode": "CA06",         "transporttypecode": "3",
 * 空运进口        "productcode": "CA05",        "transporttypecode": "3"
 * 物流园报关
 * 陆运
 *         国内货运险        "productcode": "CA01","transporttypecode": "4",
 *         出口货运险        "productcode": "CA06","transporttypecode": "",
 *         进口货运险        "productcode": "CA05","transporttypecode": "",
 * 铁路运输
 *         国内非公路        "productcode": "CA01","transporttypecode": "5",
 *         出口货运险        "productcode": "CA06","transporttypecode": "",
 *         进口货运险        "productcode": "CA05","transporttypecode": "",
 * 内贸水运                        "productcode": "CA01","transporttypecode": "5",..
 **/
export const returnRouteCode = (r: string) => {
  if (r === '/e-insurance') {
    return {
      productCode: 'CA06',
      transportTypeCode: '',
    }
  } else if (r === '/i-insurance') {
    return {
      productCode: 'CA05',
      transportTypeCode: '',
    }
  } else if (r === '/domestic-insure') {
    return {
      productCode: 'CA01',
      transportTypeCode: '4',
    }
  } else if (r === '/non-highway') {
    return {
      productCode: 'CA01',
      transportTypeCode: '5',
    }
  } else if (r === '/cross-insure') {
    return {
      productCode: 'CA11',
      transportTypeCode: '',
    }
  }
}
export const returnProductCode = (queryType: number) => {
  // if (queryType === 1) {
  //     return {
  //         productCode: 'CA06',
  //         transportTypeCode: ''
  //     }
  // } else if (queryType === 2) {
  //     return {
  //         productCode: 'CA05',
  //         transportTypeCode: ''
  //     }
  // } else if (queryType === 3) {
  //     return {
  //         productCode: 'CA01',
  //         transportTypeCode: '4'
  //     }
  // } else if (queryType === 4) {
  //     return {
  //         productCode: 'CA01',
  //         transportTypeCode: '5'
  //     }
  // } else if (queryType === 5) {
  //     return {
  //         productCode: 'CA11',
  //         transportTypeCode: ''
  //     }
  // }
  const arr = [
    { productCode: 'CA06', transportTypeCode: '' },
    { productCode: 'CA05', transportTypeCode: '' },
    { productCode: 'CA01', transportTypeCode: '4' },
    { productCode: 'CA01', transportTypeCode: '5' },
    { productCode: 'CA11', transportTypeCode: '' },

    { productCode: 'CA06', transportTypeCode: '' },
    { productCode: 'CA066', transportTypeCode: '' },

    { productCode: 'CA11', transportTypeCode: '' },
    { productCode: 'CB12', transportTypeCode: '' },
    { productCode: 'CB13', transportTypeCode: '' },
    { productCode: 'CB14', transportTypeCode: '' },
    { productCode: 'CB15', transportTypeCode: '' },
  ]
  return arr[queryType - 1]
}

export const traditionalNotWYList = () => {
  return [
    { label: t('insuranceType.export'), value: 1 },
    { label: t('insuranceType.import'), value: 2 },
    { label: t('insuranceType.domestic'), value: 3 },
    { label: t('insuranceType.domesticNonHighway'), value: 4 },
  ]
}

export const traditionalWYList = () => {
  return [
    { label: t('insuranceType.exportFCLPortToPort'), value: 6 },
    { label: t('insuranceType.exportFCLWarehouseToWarehouse'), value: 7 },
  ]
}

export const traditionalHGJList = () => {
  return [
    {
      label: t('insuranceType.export'),
      value: 1,
      formCode: FormCode.export_insure_add,
    },
    {
      label: t('insuranceType.import'),
      value: 2,
      formCode: FormCode.insure_add,
    },
    {
      label: t('insuranceType.domestic'),
      value: 3,
      formCode: FormCode.inner_insure_add,
    },
  ].filter((i) => (isGlobal ? i.value !== 3 : true))
}

export const acrossWYList = () => {
  return [
    { label: t('insuranceType.eCommerceLineFull'), value: 8 },
    { label: t('insuranceType.eCommerceLineTail'), value: 9 },
    { label: t('insuranceType.digitalProduct'), value: 10 },
    { label: t('insuranceType.dropShipping'), value: 11 },
    { label: t('insuranceType.parcelConsolidation'), value: 12 },
  ]
}

/**
 *@Description 货代 系统 关口类型  .
 *@Return .
 **/
export const saasTypeOption = [
  '海运出口',
  '海运进口',
  '空运出口',
  '空运进口',
  '物流园报关',
  '陆运',
  '铁路运输',
  '内贸水运',
  '自拼',
]
/**
 *@Description 货代 系统 港口类型 对应的key .
 *@Return .
 **/
export const returnBussTypeKey: any = {
  陆运: 'land',
  自拼: 'lcl_order',
  空运出口: 'air_export',
  空运进口: 'air_import',
  海运出口: 'shipping_export',
  海运进口: 'shipping_import',
  铁路运输: 'railway_transport',
  内贸水运: 'waterborne_inside_trade',
  物流园报关: 'logistics_park_customs',
}
export const returnTableType: any = {
  陆运: 'land_table',
  自拼: 'lcl_order_table',
  空运出口: 'air_export_table',
  空运进口: 'air_import_table',
  海运出口: 'shipping_export_table',
  海运进口: 'shipping_import_table',
  铁路运输: 'railway_transport_table',
  内贸水运: 'waterborne_inside_trade_table',
  物流园报关: 'logistics_park_customs_table',
}

export const getOutputTypeOptions = () => {
  return [
    {
      value: 0,
      label: t('status.unreported'),
    },
    {
      value: 1,
      label: t('status.quoting'),
    },
    {
      value: 2,
      label: t('status.issued'),
    },
    {
      value: 9,
      label: t('status.returned'),
    },
  ]
}
export const getOutputType = (val: number) => {
  return getOutputTypeOptions().find((item) => item.value === val)?.label
}
export const getOutputTypeClass = (val: number) => {
  const obj: Record<string, string> = {
    0: 's-gray',
    1: 's-blue',
    2: 's-green',
    9: 's-gray',
    999: '-',
  }

  return `status ${obj[val]}`
}

export const returnInvoiceCurrency = () => {
  return [
    {
      value: 'USD',
      label: 'USD',
    },
    {
      value: 'CNY',
      label: 'CNY',
    },
    {
      value: 'EUR',
      label: 'EUR',
    },
    {
      value: 'JPY',
      label: 'JPY',
    },
    {
      value: 'AUD',
      label: 'AUD',
    },
    {
      value: 'CAD',
      label: 'CAD',
    },
    {
      value: 'SGD',
      label: 'SGD',
    },
    {
      value: 'GBP',
      label: 'GBP',
    },
    {
      value: 'HKD',
      label: 'HKD',
    },
    {
      value: 'RUB',
      label: 'RUB',
    },
    {
      value: 'THB',
      label: 'THB',
    },
    {
      value: 'NZD',
      label: 'NZD',
    },
    {
      value: 'KRW',
      label: 'KRW',
    },
    {
      value: 'TWD',
      label: 'TWD',
    },
    {
      value: 'CHF',
      label: 'CHF',
    },
    {
      value: 'MYR',
      label: 'MYR',
    },
  ]
}

export const hgjDateTypeOptions = () => {
  return [
    { label: 'AS PER B/L', value: '04' },
    { label: 'Month dd,yyyy', value: '02' },
  ]
}

/**
 *@Description 海管家投保详情页页面操作模式
 *@Return
 * NEW.投保；CORRECT.批改；EDIT.编辑；VIEW.查看；COPY.复制；CHARGE_BACK.三方回调跳转 .
 * COPY, CACHE是把数据带入的NEW，都是新增
 * CORRECT是提交保单后的EDIT，都是编辑
 *。
 **/
export enum ManifestDetailAction {
  NEW = 'new',
  COPY = 'copy',
  CACHE = 'cache',
  EDIT = 'edit',
  CORRECT = 'correct',
  VIEW = 'view',
  CHARGE_BACK = 'chargeBack',
}

/**
 *@Description 海管家投保详情页页面类型
 *@Return
 * ACROSS.进出口；DOMESTIC.国内；
 *。
 **/
export enum ManifestDetailType {
  // 进出口
  ACROSS = 'across',
  // 国内
  DOMESTIC = 'domestic',
}

/**
 *@Description 海管家投保详情页页面模式
 * NEW.投保；CORRECT.批改；EDIT.编辑；VIEW.查看；COPY.复制；
 **/
export enum ManifestDetailMode {
  /** 投保 */
  NEW = 'new',
  /** 批改 */
  CORRECT = 'correct',
  /* 编辑 */
  EDIT = 'edit',
  /** 查看 */
  VIEW = 'view',
  /** 复制 */
  COPY = 'copy',
  /** 缓存 */
  CACHE = 'cache',
}

/**
 *@Description /insures/hgj/policyInfo接口依赖入参，这些参数随便一个变动都需要重新调接口
 *@Return
 *。
 **/
export const policyParamsList = () => {
  return [
    'insureRemark',
    'addClauseIds',
    'addition',
    'cargoValue',
    'cargoValueCurrency',
    'dCountryCode',
    'departureStartDate',
    'frClauseContent',
    'goodsCategoryCode',
    'insCompanyCode',
    'mainClauseId',
    'packageTypeCode',
    'pCountryCode',
    'productCode',
    'transporttypecode',
    'loadTypeCode',
  ] as const
}

/**
 *@Description /insures/hgj/policyInfo接口必填项
 *@Return
 *。
 **/
export const policyParamsMustFillList = () => {
  return [
    'addition',
    'cargoValue',
    'cargoValueCurrency',
    'dCountryCode',
    'departureStartDate',
    'goodsCategoryCode',
    'mainClauseId',
    'packageTypeCode',
    'pCountryCode',
    'productCode',
    'transporttypecode',
  ] as const
}

/**
 *@Description /insures/hgj/premiumResult接口依赖入参，这些参数随便一个变动都需要重新调接口
 *@Return
 *。
 **/
export const premiumResultList = () => {
  return [
    'id',
    'productCode',
    'insCompanyCode',
    'transporttypecode',
    'cargoValue',
    'cargoValueCurrency',
    'addition',
    'insrate',
    'policyno',
  ]
}

/**
 *@Description /insures/hgj/premiumResult接口必填项
 *@Return
 *。
 **/
export const premiumMustFillList = () => {
  return [
    'productCode',
    'transporttypecode',
    'cargoValue',
    'cargoValueCurrency',
    'addition',
  ]
}

/**
 *@Description 复制需要带入的字段
 *@Return
 *。
 **/
export const copyParamsList = () => {
  return [
    'productCode',
    'insCompanyCode',
    'insuredUser',
    'address',
    'concat',
    'phone',
    'cardNumber',
    'packageTypeCode',
    'goodsMarksDesc',
    'goodsMt',
    'goodsMarks',
    'goodsCategoryCode',
    'cargoValueCurrency',
    'addition',
    'transporttypecode',
    'loadTypeCode',
    'pCountryCode',
    'dCountryCode',
    'startLocation',
    'arriveLocation',
    'claimAddress',
    'isaspreBill',
    'mainClauseId',
    'addClauseIds',
    'workNumber',
    'insureRemark',
    'insureCompanyName',
  ]
}

/**
 * nas 上传base url
 */
export const NAS_BASE_URL =
  import.meta.env.VITE_NAS_BASE_URL || import.meta.env.VITE_BASE_URL

/** 通道 */
export enum ChannelCode {
  /** 恪保 */
  KB = 'KB',
  /** 广州人保 */
  RB = 'RB',
  /** 广州人保-越南 */
  RBGZVN = 'RB-GZ-VN',
  /** 平安上海*/
  PA = 'PA-SH',
  /** 苏州太平洋 */
  TPY = 'TB-SZ',
  /** 苏州人保 */
  SZRB = 'RB-SZ',
  /** 申能-苏州 */
  SNSZ = 'SN-SZ',
  /** 大地保险 */
  DD = 'DD-QD',
  /** 深圳太平洋跨境货运险 */
  TBSHZ = 'TB-SHZ',
}
/** 保险appName */
export const APP_NAME = 'saas-insurance'

/** 投保表单code */
export enum FormCode {
  /** 进口投保页 */
  insure_add = 'HGJ-RB-IMPORT',
  /** 出口投保页 */
  export_insure_add = 'HGJ-RB-EXPORT',
  /** 进口批改页 */
  insure_change = 'HGJ-RB-IMPORT-CHANGE',
  /** 出口批改页 */
  export_insure_change = 'HGJ-RB-EXPORT-CHANGE',
  /** 国内投保页 */
  inner_insure_add = 'HGJ-RB-INNER',
  /** 国内批改页 */
  inner_insure_change = 'HGJ-RB-INNER-CHANGE',
}

/** 海外站-投保表单code */
export enum FormCodeIsGlobal {
  /** 进口投保页 */
  insure_add = 'HGJ-RB-GZ-VN-IMPORT',
  /** 出口投保页 */
  export_insure_add = 'HGJ-RB-GZ-VN-EXPORT',
  /** 进口批改页 */
  insure_change = 'HGJ-RB-GZ-VN-IMPORT-CHANGE',
  /** 出口批改页 */
  export_insure_change = 'HGJ-RB-GZ-VN-EXPORT-CHANGE',
  /** 国内投保页 */
  inner_insure_add = 'HGJ-RB-GZ-VN-INNER',
  /** 国内批改页 */
  inner_insure_change = 'HGJ-RB-GZ-VN-INNER-CHANGE',
}

export enum ProductCode {
  /** 出口货运险 */
  EXPORT_HAZARD = 'CA06',
  /** 进口货运险 */
  IMPORT_HAZARD = 'CA05',
  /** 国内货运险 */
  DOMESTIC_HAZARD = 'CA01',
  /** 跨境货运险 */
  CROSS_BORDER = 'CA11',
}
/** 表单规则的前缀，用于拼接获取表单配置 */
export enum OutputType {
  /** 出口货运险 */
  CA06 = 'EXPORT',
  /** 进口货运险 */
  CA05 = 'IMPORT',
  /** 国内货运险 */
  CA01 = 'INNER',
}

/**
 *@Description 属性类型（文本：TEXT、单选：RADIO、多选：MULT、下拉：SELECT、远程下拉：REMOTE、日期：DATE、时间：DATE_TIME）
 *@Return
 **/
export enum FieldType {
  TEXT = 'TEXT',
  RADIO = 'RADIO',
  MULT = 'MULT',
  SELECT = 'SELECT',
  REMOTE = 'REMOTE',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
}

/**
 * 运输方式
 */
export enum TransportType {
  /** 海运 */
  SEA = '1',
}

/**
 * 扩展请求头
 */
export const expandHeader = {
  locale: getCurrentLanguage() || 'zh-CN',
  Language: getCurrentLanguage() || 'zh-CN',
  'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
}
